const DISCORD_INVITE = "https://discordapp.com/invite/Ars8Hkr2PC";
const GITHUB_ORGANISATION = "https://github.com/dectalk";
const HOMEPAGE_GITHUB_ISSUES = "https://github.com/dectalk/homepage/issues";
const MAILING_LIST = "https://groups.io/g/dectalk";

export { DISCORD_INVITE, GITHUB_ORGANISATION, HOMEPAGE_GITHUB_ISSUES, MAILING_LIST };
